import { render, staticRenderFns } from "./UnifiedControlDescriptor.vue?vue&type=template&id=7354ffc4&lang=pug"
import script from "./UnifiedControlDescriptor.vue?vue&type=script&lang=js"
export * from "./UnifiedControlDescriptor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports